<template>
  <v-sheet class="d-flex align-center justify-center" :color="color" :height="height">
    <v-progress-circular indeterminate :color="colorCircular" :size="size" width="2" />
  </v-sheet>
</template>
<script>
export default {
  name: 'Loader',
  props: {
    height: {
      type: [String, Number],
      default: '80',
    },
    size: {
      type: [String, Number],
      default: '40',
    },
    color: {
      type: String,
      default: 'white',
    },
    colorCircular: {
      type: String,
      default: 'blue darken-1',
    },
  },
}
</script>
